/**
 * recharts は SVG の fill/stroke に CSS 変数 (var(--x)) を直接渡せないため、
 * 実際の色文字列へ解決して渡す必要がある.
 * jsdom では getComputedStyle().getPropertyValue() が空文字を返すので、
 * その場合は fallback (token.css の実値相当) を使う.
 */
export function resolveCssVar(name: string, fallback: string): string {
  if (typeof window === "undefined" || typeof document === "undefined") return fallback;
  const root = document.documentElement;
  const value = window.getComputedStyle(root).getPropertyValue(name).trim();
  return value !== "" ? value : fallback;
}

/** ダッシュボードチャートの配色 (token.css の実値を fallback に持つ). */
export const chartColors = {
  /** 折れ線: 完了 (濃いインク) */
  completed: () => resolveCssVar("--ink", "#1a1a1a"),
  /** 折れ線/棒: 予定・未配送 (アクセント) */
  planned: () => resolveCssVar("--accent", "oklch(0.62 0.18 35)"),
  /** グリッド線 */
  grid: () => resolveCssVar("--rule-soft", "#d4d4cc"),
  /** 軸ラベル */
  axis: () => resolveCssVar("--ink-3", "#6b6b67"),
} as const;

/** 円グラフ 4 区分の配色 (buildPieData の name と対応). */
export function pieColor(name: string): string {
  switch (name) {
    case "未配送":
      return resolveCssVar("--warn", "oklch(0.72 0.15 80)");
    case "配送中":
      return resolveCssVar("--info", "oklch(0.55 0.11 230)");
    case "完了":
      return resolveCssVar("--ok", "oklch(0.55 0.12 150)");
    case "キャンセル":
      return resolveCssVar("--danger", "oklch(0.58 0.19 25)");
    default:
      return resolveCssVar("--ink-3", "#6b6b67");
  }
}
